<template>
    <section id="contact-popup">
        <div id="container-contacts-form" class="container d-flex">
            <div class="text-align-start formHeader">
                <img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo" style="max-width: 2em; margin-right: .5em">
                <span style="vertical-align: middle; font-weight: 600">Contatos</span>
            </div>
            <div id="div-title">
                <i class="fa fa-address-book fa-2x" aria-hidden="true" style="color: rgb(28,134,154)"></i>
                <h2 id="container-title">Cadastro de Contatos</h2>
            </div>
            <form action="" id="contacts-form">
                <div class="input-group">
                    <label for="contactName">Nome</label>
                    <input 
                        class="form-control" 
                        name="contactName" 
                        type="text" 
                        v-model="contact.name" 
                        placeholder="Insira o nome do contato" 
                        required>
                </div>
                <div class="input-group">
                    <label for="contactPhone">Telefone</label>
                    <vue-tel-input 
                        id="phone-input" 
                        defaultCountry=""
                        mode="international" 
                        v-model="contact.phone"
                        :inputOptions="options">
                    </vue-tel-input>
                </div>
                <div class="input-group mt-2">
                    <label for="unique_key">Funcional</label>
                    <select class="form-control mr-3 ml-3" name="id-cpf" id="id-cpf" v-model="idCpf" style="flex: 1">
                        <option value="id">ID</option>
                        <option value="cpf">CPF</option>
                        <option value="cnpj">CNPJ</option>
                    </select>
                    <input class="form-control"
                        name="contactKey"
                        type="text"
                        v-model="contact.unique_key"
                        :placeholder="maskPlaceholder"
                        @input="applyMask"
                        style="flex: 4"
                    >
                </div>
                <div class="input-group mt-2 d-flex2 align-items-center">
                    <label for="type" class="label-inline">Tipo</label>
                    <v-select :options="optionsDependentes" v-model="contact.number_contact" name="type" class="select-inline"></v-select>
                </div>
                <div class="input-group mt-2 d-flex justify-content-between">
                    <div class="field-container half-width">
                        <label for="company">Empresa</label>
                        <v-select :options="optionsEmpresas" v-model="contact.company_name" name="company"></v-select>
                    </div>
                    <div class="field-container half-width" v-if="subCompanyShow()">
                        <label for="subcompany">Sub-empresa</label>
                        <v-select :options="optionsSubEmpresasFilter()" v-model="contact.corporation" name="subcompany"></v-select>
                    </div>
                </div>
                <div class="input-group d-flex">
                    <span><b>Programa: </b>{{ getProgram() }}</span>
                    <span><b>Número: </b>{{ getNumber() }}</span>
                </div>


                <div v-if="saving">
                    <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Salvando contato...</strong></p>
                </div>                
                <div v-else >
                    <button    
                        type="submit"
                        class="btn btn-success"
                        id="btn-save"
                        form="chamadoForm"
                        @click.prevent="saveContact()"
                    ><i class="fas fa-check"></i>
                        Salvar
                    </button>
                    <button 
                        type="submit"
                        class="btn btn-danger"
                        id="btn-cancel"
                        form="chamadoForm"
                        @click.prevent="resetContact()"
                    ><i class="fas fa-window-close fa-fw"></i>
                        Cancelar
                    </button>
                </div>
            </form>
        </div>
    </section>
</template>
    
<script>

import {mapActions, mapGetters, mapMutations} from 'vuex';
import swal from 'sweetalert';
import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask)

export default {
    name: "ContatosRapido",
    props: ['addWppContact'],
    data(){
        return {
            subCompanyId: [4,5,6],
            optionsDependentes: ['Dependente', 'Funcionário'],
            optionsEmpresas: [],
            optionsSubEmpresas: [],
            contact: {
                name: "",
                phone: "",
                unique_key: '',
                number_contact:'',
                company_name: '',
                corporation: ''
            },
            saving: false,
            idCpf: "cpf",
            options: {
                placeholder: 'Insira o telefone',
                required: true
            }
        }
    },
    async created(){
        const res = await axios.get('/api/companies');
        const subRes = await axios.get('/api/subcompanies');

        this.optionsEmpresas = res.data;
        this.optionsSubEmpresas = subRes.data;
    },
    components: {
        ...mapGetters(['getContacts']),
    },
    methods:{
        ...mapActions(["transferOptions"]),
        subCompanyShow(){
            try{
                const found = this.optionsEmpresas.filter(el => el.label == this.contact.company_name.label)

                if(this.subCompanyId.includes(parseInt(found[0].code))){
                    return true;
                }

                return false;

            }catch(e){

                return false;

            }
        }, 
        optionsSubEmpresasFilter(){
            
                if( this.contact.company_name == null){
                    this.company_name = {}
                    this.company_name.label = null
                }

                const filter = this.optionsSubEmpresas.filter(el => ((el.Empresa == this.contact.company_name) || el.Empresa == this.contact.company_name.label));
                return filter;
        },
        getProgram(){
            try{
                if(this.contact.company_name.programa) return this.contact.company_name.programa;

                return (found) ? found[0].programa : '';

            }catch(e){
                return '';
            }
        }, 
        getNumber(){
            try{
                if(this.contact.company_name.numero) return this.contact.company_name.numero;
            
            }catch(e){
                return '';
            }
        },
        applyMask() {
            if (this.idCpf === 'cpf') {
                let value = this.contact.unique_key.replace(/\D/g, '').slice(0, 11);
                this.contact.unique_key = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
            } else if (this.idCpf === 'cnpj') {
                let value = this.contact.unique_key.replace(/\D/g, '').slice(0, 14);
                this.contact.unique_key = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
            }
        },
        checkForm() {
            if (this.contact.name == undefined || this.contact.name == null || this.contact.name == '') {
                Swal.fire({
                    html: 'O campo "Nome Contato" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false  
            }

            if (this.contact.phone == undefined || this.contact.phone == null || this.contact.phone == '') {
                Swal.fire({
                    html: 'O campo "Telefone" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false;  
            } else {
                return true;
            }
        },
        saveContact: function(){
            if(this.checkForm()){
                this.saving = true
                this.contact.company_name = (this.contact.company_name && this.contact.company_name.label) ? this.contact.company_name.label : this.contact.company_name;
                this.contact.corporation = (this.contact.corporation && this.contact.corporation.label) ? this.contact.corporation.label : this.contact.corporation;

                axios.post("dialer/saveContact", this.contact).then(data=> {
                    if(data.data.passed == false){
                        let str = '';
                        Object.keys(data.data.errors).forEach(key => {
                            str += data.data.errors[key];
                        });

                        Swal.fire({
                            type: "warning",
                            title: "Não foi possível inserir o cliente a base",
                            text: str
                        }).then(comfirm =>{
                            this.saving = false
                        })
                        return;
                    }
                    Swal.fire({
                        type: "success",
                        title: "Feito!",
                        text: "Contato salvo com sucesso!"
                    }).then(comfirm =>{
                  	  this.saving = false
                  	  this.contact.name = ""
                  	  this.contact.phone = ""
                      this.contact.corporation =  ""
                      this.contact.unique_key =  ""
                      this.contact.company_name =  ""
                      this.contact.number_contact = ""
                      this.$emit('closeContacts')
	            });
                    
                })
            }
        },

        resetContact: function(){
            Swal.fire({
                title: 'Deseja descartar as informações?',
                text: 'Você perderá as alterações não salvas!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: 'rgb(28,134,154)',
                confirmButtonText: 'Sim, descartar',
                cancelButtonText: 'Voltar ao formulário'
            }).then((result) => {
                if(result.value){
                    this.contact.name = ""
                    this.contact.phone = ""
                    this.contact.name = ""
                    this.contact.phone = ""
                    this.contact.corporation =  ""
                    this.contact.unique_key =  ""
                    this.contact.company_name =  ""
                    this.contact.number_contact = ""
                    this.$emit('closeContacts')
                }
            })
        },
        async setClientData(client) {		
			if( (client.phone || client.name) && client.type == 'chat'){		
                
                let phoneArr = client.phone.split('@');
				let phoneEdited = phoneArr[0].substr(2);

				this.contact = {
					'name': client.name,
					'phone': phoneEdited,
				}
			}
		}
    },
    computed:{
		...mapGetters([
			'getContacts',
		]),
        ...mapActions(['setMessage']),
        maskPlaceholder() {
            if (this.idCpf === 'cpf') {
                return 'XXX.XXX.XXX-XX';
            } else if (this.idCpf === 'cnpj') {
                return 'XX.XXX.XXX/XXXX-XX';
            }else {
                return 'Id do contato';
            }
        }
    },

    watch: {
        idCpf() {
            this.contact.unique_key = "";
        },
        addWppContact(data) {
            if(data){
                const phone = data.phone
                const phoneEdited = '+' + phone ;

                if(data.cpfCnpj && data.cpfCnpj != '') {
                    if(data.cpfCnpj.length == 14){
                        this.idCpf = 'cnpj';
                    } else {
                        this.idCpf = 'cpf';
                    }
                }

                setTimeout(() => {
                    this.contact = {
                        'name': data.name,
                        'phone': phoneEdited,
                        'unique_key': data.cpfCnpj ? data.cpfCnpj : ''
                    }
                }, 500)
            }
        },
    }
}
</script>

<style scoped>

    #contact-popup{
        display: flex;
        justify-content: center;
        position: absolute;
        top: 55px;
        right: 25vw;
    }
    .formHeader {
        background-color: rgb(28,134,154);
        border-top: 3px solid #f38630;
        color: white;
        padding: 0.2em;
        display: flex;
        border-radius: 20px 20px 0px 0px
    }

    .input-group{
        width: 90%;
        align-self: center;
        line-height: 2.55;
    }

    #container-contacts-form{
        width: 50vw;
        border: solid 2px lightgray;
        border-radius: 25px;
        text-align: center;
        flex-direction: column;
        /* margin: 10px; */
        padding: 0;
        background-color: white;
    }

    #saving {
        color: rgb(28,134,154);
        font-size: 16px;
        text-align: center
    }

    #div-title {
        display: flex;
        flex-direction: column;
        margin: 20px;
    }

    #contacts-form{
        display: flex;
        flex-direction: column;
        text-align: center;
    }

    #buttonGroup {
        display: flex;
        justify-content: center;
    }
    
    #phone-input{
        height: 2.5em;
        align-self: center;
        flex: 3;
    }

    #btn-save {
        border: solid 2px #008000;
        border-radius: 20px;
        background-color: #008000;
        color: white;
        transition: 0.5s
    }
    
    #btn-save:hover {
        color: #008000;
        background-color: white;

    }

    #btn-cancel {
        border: solid 2px #b30000;
        border-radius: 20px;
        background-color: #b30000;
        color: white;
        transition: 0.5s
    }
    
    #btn-cancel:hover {
        color: #b30000;
        background-color: white;

    }

    section {
        display: flex;
        justify-content: center;
    }

    h2 {
        color: rgb(28,134,154)
    }

    label{
        margin: 10px;
        font-size: 16px;
        font-weight: 500;
    }

    select {
        align-self: center;
    }

    input {
        width: 40px;
        align-self: center;
    }

    button {
        width: 120px;
        margin: 20px;
        border-radius: 10px !important
    }

    .d-flex {
        display: flex;
        justify-content: space-between;
    }

    .full-width {
        width: 100%; /* Permite que o campo "Tipo" ocupe toda a largura */
    }

    .half-width {
        flex: 1; /* Permite que cada campo ocupe espaço igual, mas ajusta-se conforme o conteúdo */
        min-width: 0; /* Evita que o flex item cresça além do necessário */
        padding-right: 10px; /* Espaçamento entre os campos */
    }

    .half-width:last-child {
        padding-right: 0; /* Remove o espaçamento no último item para alinhamento */
    }

    .d-flex2 {
        display: flex;
        align-items: center; /* Centraliza os itens verticalmente */
        gap: 10px; /* Espaçamento entre o rótulo e o v-select */
    }

    .label-inline {
        margin-right: 8px; /* Ajuste conforme necessário para alinhar com o v-select */
        white-space: nowrap; /* Evita que o texto do rótulo quebre em mais de uma linha */
    }

    .select-inline {
        flex-grow: 1; /* Permite que o v-select ocupe o máximo de espaço possível */
    }


</style>
